const className = 'duration';

const isAvailable = ({duration, expirationDate}) => Boolean(duration) && Boolean(expirationDate) === false;

const getProps = ({duration}) => duration;

export default {className, isAvailable, getProps};
